module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.20345/img/link-connector.svg"